import {partnerErrors} from './partnerRules';
import React, {useState, useEffect} from 'react';
import {useHistory, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {ProgressBar} from 'primereact/progressbar';
import {Form, Field} from 'react-final-form';
import {Button} from "primereact/button";
import {Dropdown} from "primereact/dropdown";
import {InputText} from "primereact/inputtext";
import {classNames} from "primereact/utils";
import axios from "axios";
import {InputSwitch} from "primereact/inputswitch";
import { InputNumber } from 'primereact/inputnumber';

const PartnerFormComponent = (props) => {

  const {t} = props;
  const history = useHistory();
  const {entity, id} = useParams();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({});
  const [countries, setCountries] = useState([])

  const countryPrefixes = [
    { label: 'US +1', value: '+1' },
    { label: 'RU +7', value: '+7' },
    { label: 'ZA +27', value: '+27' },
    { label: 'GR +30', value: '+30' },
    { label: 'BE +32', value: '+32' },
    { label: 'FR +33', value: '+33' },
    { label: 'ES +34', value: '+34' },
    { label: 'HU +36', value: '+36' },
    { label: 'IT +39', value: '+39' },
    { label: 'RO +40', value: '+40' },
    { label: 'CH +41', value: '+41' },
    { label: 'AT +43', value: '+43' },
    { label: 'GB +44', value: '+44' },
    { label: 'DK +45', value: '+45' },
    { label: 'SE +46', value: '+46' },
    { label: 'NO +47', value: '+47' },
    { label: 'PL +48', value: '+48' },
    { label: 'DE +49', value: '+49' },
    { label: 'MX +52', value: '+52' },
    { label: 'AR +54', value: '+54' },
    { label: 'BR +55', value: '+55' },
    { label: 'CL +56', value: '+56' },
    { label: 'CO +57', value: '+57' },
    { label: 'MY +60', value: '+60' },
    { label: 'AU +61', value: '+61' },
    { label: 'ID +62', value: '+62' },
    { label: 'PH +63', value: '+63' },
    { label: 'NZ +64', value: '+64' },
    { label: 'TH +66', value: '+66' },
    { label: 'JP +81', value: '+81' },
    { label: 'KR +82', value: '+82' },
    { label: 'VN +84', value: '+84' },
    { label: 'CN +86', value: '+86' },
    { label: 'TR +90', value: '+90' },
    { label: 'IN +91', value: '+91' },
    { label: 'PK +92', value: '+92' },
    { label: 'SS +211', value: '+211' },
    { label: 'DZ +213', value: '+213' },
    { label: 'TN +216', value: '+216' },
    { label: 'RW +250', value: '+250' },
    { label: 'IE +353', value: '+353' },
    { label: 'AL +355', value: '+355' },
    { label: 'CY +357', value: '+357' },
    { label: 'FI +358', value: '+358' },
    { label: 'LT +370', value: '+370' },
    { label: 'LV +371', value: '+371' },
    { label: 'EE +372', value: '+372' },
    { label: 'MD +373', value: '+373' },
    { label: 'BY +375', value: '+375' },
    { label: 'UA +380', value: '+380' },
    { label: 'RS +381', value: '+381' },
    { label: 'HR +385', value: '+385' },
    { label: 'SI +386', value: '+386' },
    { label: 'MK +389', value: '+389' },
    { label: 'CZ +420', value: '+420' },
    { label: 'SK +421', value: '+421' },
    { label: 'UY +598', value: '+598' },
    { label: 'HK +852', value: '+852' },
    { label: 'TW +886', value: '+886' },
    { label: 'SA +966', value: '+966' },
    { label: 'AE +971', value: '+971' },
    { label: 'IL +972', value: '+972' }
  ];

  const [phoneCountryCode, setPhoneCountryCode] = useState(null);
  const [phoneNumber, setPhoneNumber] = useState('');

  const validate = (data) => {
    let errors = {};
    // if (!data.company) {
    //   errors.company = 'Kötelező mező';
    // }
    // if (!data.partner) {
    //   errors.partner = 'Kötelező mező';
    // }
    errors = partnerErrors({...formData,...data}, t);
    return errors;
  };
  const onSubmit = (data, form) => {
    setLoading(true)
    const payload = {
      ...formData,
      address_detail: data.address_detail ?? formData.address_detail ?? null,
      phone: buildPhoneValue()
    }
    delete payload.phone_country_code;
    if (id) {
      apiCall('patch', "/api/v2/partner/" + (window.App.urlVars().partnerId ?? id), payload)
        .then(response => {
          window.App.toastShow('success', t('toastSaveSuccess'));
          window.App.setState({rerenderPartnerList: Math.random()})
          if (props.goback === true) {
            history.push(props.backlink);
          } else {
            history.push('/partner/partner/update/' + response.data.data.id);
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    } else {
      apiCall('post', "/api/v2/partner", payload)
        .then(response => {
          window.App.toastShow('success', t('toastSaveSuccess'));
          window.App.setState({rerenderPartnerList: Math.random()})
            if (props.pick === true) {
              window.App.setState({
                newPartnerId: response.data.data.id,
                newPartnerName: response.data.data.name,
                sidebarPartnerCreate: false,
              });
              window.App.toastShow('success', t('toastSaveSuccess'));
              window.App.setState({ rerenderPartnerList: Math.random() });
              return;
            }
           if (props.goback === true && props.backlink) {
            const sep = props.backlink.includes('?') ? '&' : '?';
            history.push(
              props.backlink +
                sep +
                'partnerId=' + response.data.data.id +
                '&partnerName=' + encodeURIComponent(response.data.data.name)
            );
            return;
          } else {
            history.push('/partner/partner/update/' + response.data.data.id);
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
  };

  const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
  const getFormErrorMessage = (meta) => {
    return isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>;
  };

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  const parsePhoneValue = (phone) => {
    const raw = (phone || '').toString().trim();
    if (!raw) {
      return {
        countryCode: null,
        number: ''
      };
    }
    const sortedPrefixes = [...countryPrefixes].sort((a, b) => b.value.length - a.value.length);
    const foundPrefix = sortedPrefixes.find(prefix =>
      raw === prefix.value || raw.startsWith(prefix.value + ' ') || raw.startsWith(prefix.value)
    );
    if (!foundPrefix) {
      return {
        countryCode: null,
        number: raw
      };
    }
    return {
      countryCode: foundPrefix.value,
      number: raw.substring(foundPrefix.value.length).trim()
    };
  };

  const buildPhoneValue = () => {
    const prefix = phoneCountryCode || '';
    const number = (phoneNumber || '').toString().trim();
    return [prefix, number].filter(Boolean).join(' ');
  };

  useEffect(() => {
    if (id) {
      setLoading(true);
      apiCall('get', "/api/v2/partner/" + id)
        .then(response => {
          const parsedPhone = parsePhoneValue(response.data.data.phone);
          setPhoneCountryCode(parsedPhone.countryCode);
          setPhoneNumber(parsedPhone.number);
          setFormData(response.data.data);
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
    apiCall('get', "/api/v2/country")
      .then(response => {
        const countryOptions = Array.isArray(response.data)
          ? response.data
          : Array.isArray(response.data?.data)
            ? response.data.data
            : [];

        setCountries(countryOptions);
        if (!id) {
          const defaultCountry = process.env.REACT_APP_DEFAULT_COUNTRY;
          setFormData(prev => ({
            ...prev,
            address_country_code: prev.address_country_code ?? defaultCountry
          }));
        }
      })
      .catch(error => {
          console.log(error);
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
  }, [])

  return (
    <div className={"partner-form widget"}>
      {loading &&
        <ProgressBar mode="indeterminate"
                     style={{height: '5px', position: "absolute", top: 0, left: 0, borderRadius: 0,}}></ProgressBar>
      }
      <Form onSubmit={onSubmit} initialValues={formData}
            validate={validate} render={({handleSubmit, submitting}) => (
        <form onSubmit={handleSubmit} className="">
          <div className={"p-grid"}>
            <div className={"p-col-12 p-md-9 p-lg-9"}>
              <Field name="name" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="name"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldContactName')}</label>
                  <span className="p-d-block">
                      <InputText id="name" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     name: e.target.value
                                   })
                                 }}
                                 value={formData.name}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-md-3 p-lg-3"}>
              <Field name="type" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="type"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldType')}</label>
                  <span className="p-d-block">
                    <Dropdown options={window.App.sortDropdownOptions([
                      {
                        name: t('person'),
                        id: "PERSON"
                      },
                      {
                        name: t('organisation'),
                        id: "ORGANISATION"
                      },
                      {
                        name: t('other'),
                        id: "OTHER"
                      },
                    ], "name")}
                              optionLabel="name"
                              optionValue="id"
                              id={"type"}
                              emptyMessage={t('noTypeYet')}
                              onChange={(e) => {
                                setFormData({
                                  ...formData,
                                  type: e.value
                                })
                              }}
                              value={formData.type}
                              showClear
                    />
                  </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
          </div>
          <div className={"p-grid p-mt-1"}>
            <div className={"p-col-12"}>
              <h3>
                {formData && formData.type === 'PERSON' &&
                  <>
                    <i className={"pi pi-map-marker"}></i> {t('residentialAddress')}
                  </>
                }
                {formData && formData.type === 'ORGANISATION' &&
                  <>
                    <i className={"pi pi-map-marker"}></i> {t('headquartersAddress')}
                  </>
                }
              </h3>
            </div>
          </div>
          <div className={"p-grid"}>
            <div className={"p-col-12 p-md-3 p-lg-3"}>
              <Field name="address_country_code" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="address_country_code"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldAddressCountry')}</label>
                  <span className="p-d-block">
                      <Dropdown options={window.App.sortDropdownOptions(countries, "name")}
                                optionLabel="name"
                                optionValue="code"
                                id={"address_country_code"}
                                emptyMessage={t('noCountryYet')}
                                onChange={(e) => {
                                  setFormData({
                                    ...formData,
                                    address_country_code: e.value
                                  })
                                }}
                                value={formData.address_country_code}
                                showClear
                      />
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-md-2 p-lg-2"}>
              <Field name="address_postal_code" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="address_postal_code"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldAddressPostalCode')}</label>
                  <span className="p-d-block">
                      <InputText id="address_postal_code" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     address_postal_code: e.target.value
                                   })
                                 }}
                                 value={formData.address_postal_code}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-md-3 p-lg-3"}>
              <Field name="address_city" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="address_city"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldAddressCity')}</label>
                  <span className="p-d-block">
                      <InputText id="address_city" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     address_city: e.target.value
                                   })
                                 }}
                                 value={formData.address_city}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-md-4 p-lg-4"}>
              <Field name="address_detail" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="address_detail"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldAddressDetail')}</label>
                  <span className="p-d-block">
                      <InputText id="address_detail" {...input}
                                 onChange={(e) => {
                                   input.onChange(e.target.value);
                                   setFormData(prev => ({
                                     ...prev,
                                     address_detail: e.target.value
                                   }));
                                 }}
                                 value={formData.address_detail ?? ''}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
          </div>
          {formData.type === 'ORGANISATION' &&
            <>
              <div className={"p-grid p-mt-1"}>
                <div className={"p-col-12"}>
                  <h3>
                    <i className={"pi pi-file"}></i> {t('identifiers')}
                  </h3>
                </div>
              </div>
              <div className={"p-grid"}>
                <div className={"p-col-12 p-md-4 p-lg-4"}>
                  <Field name="vat_number" render={({input, meta}) => (
                    <div className="p-field p-fluid">
                      <label htmlFor="vat_number"
                             className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldVatNumber')}</label>
                      <span className="p-d-block">
                      <InputText id="vat_number" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     vat_number: e.target.value
                                   })
                                 }}
                                 onClick={() =>{
                                   document.getElementById('email').classList.remove('p-invalid');
                                   document.getElementById('email')?.parentElement?.parentElement?.parentElement?.querySelector('.p-error')?.remove()
                                 }}
                                 value={formData.vat_number}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                      {getFormErrorMessage(meta)}
                    </div>
                  )}/>
                </div>
                <div className={"p-col-12 p-md-4 p-lg-4"}>
                  <Field name="community_vat_number" render={({input, meta}) => (
                    <div className="p-field p-fluid">
                      <label htmlFor="community_vat_number"
                             className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldCommunityVatNumber')}</label>
                      <span className="p-d-block">
                      <InputText id="community_vat_number" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     community_vat_number: e.target.value
                                   })
                                 }}
                                 value={formData.community_vat_number}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                      {getFormErrorMessage(meta)}
                    </div>
                  )}/>
                </div>
                <div className={"p-col-12 p-md-4 p-lg-4"}>
                  <Field name="group_vat_number" render={({input, meta}) => (
                    <div className="p-field p-fluid">
                      <label htmlFor="group_vat_number"
                             className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldGroupVatNumber')}</label>
                      <span className="p-d-block">
                      <InputText id="group_vat_number" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     group_vat_number: e.target.value
                                   })
                                 }}
                                 value={formData.group_vat_number}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                      {getFormErrorMessage(meta)}
                    </div>
                  )}/>
                </div>
                <div className={"p-col-12 p-md-4 p-lg-4"}>
                  <Field name="other" render={({input, meta}) => (
                    <div className="p-field p-fluid">
                      <label htmlFor="other"
                             className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldOther')}</label>
                      <span className={"p-d-block"}>
                      <InputText id="other" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     other: e.target.value
                                   })
                                 }}
                                 value={formData.other}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                      {getFormErrorMessage(meta)}
                    </div>
                  )}/>
                </div>
              </div>
            </>
          }
          <div className={"p-grid p-mt-1"}>
            <div className={"p-col-12"}>
              <h3>
                <i className={"pi pi-phone"}></i> {t('centralContact')}
              </h3>
            </div>
          </div>
          <div className={"p-grid"}>
            <div className="p-col-12 p-lg-3">
              <Field name="phone_country_code" render={({ input, meta }) => (
                  <div className="p-field p-fluid">
                      <label htmlFor="phone_country_code" className={classNames({ 'p-error': isFormFieldValid(meta) })}>{props.t('fieldPhoneCountryCode')}</label>
                      <span className="p-d-block">
                          <Dropdown
                            id="phone_country_code"
                            value={phoneCountryCode}
                            options={countryPrefixes}
                            onChange={(e) => {
                              setPhoneCountryCode(e.value);
                              setFormData({
                                ...formData,
                                phone: [e.value, phoneNumber].filter(Boolean).join(' ')
                              });
                            }}
                            filter
                            showClear
                            placeholder={t('selectPlaceholder')}
                            className={classNames({ 'p-invalid': isFormFieldValid(meta) })}
                          />
                      </span>
                      {getFormErrorMessage(meta)}
                  </div>
              )} />
            </div>
            <div className={"p-col-12 p-lg-4"}>
              <Field name="phone" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="phone"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldPhone')}</label>
                  <span className="p-d-block">
                      <InputText id="phone" {...input}
                                 onChange={(e) => {
                                  setPhoneNumber(e.target.value);
                                   setFormData({
                                     ...formData,
                                     phone: [phoneCountryCode, e.target.value].filter(Boolean).join(' ')
                                   })
                                 }}
                                 value={phoneNumber}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-lg-5"}>
              <Field name="email" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="email"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldEmail')}</label>
                  <span className="p-d-block">
                      <InputText id="email" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     email: e.target.value
                                   })
                                 }}
                                 onClick={() =>{
                                   document.getElementById('vat_number').classList.remove('p-invalid');
                                   document.getElementById('vat_number')?.parentElement?.parentElement?.parentElement?.querySelector('.p-error')?.remove()
                                 }}

                                 value={formData.email}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-lg-12"}>
              <Field name="note" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="note"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldNote')}</label>
                  <span className="p-d-block">
                      <InputText id="note" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     note: e.target.value
                                   })
                                 }}
                                 value={formData.note}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
          </div>
          <div className={"p-grid p-mt-1"}>
            <div className={"p-col-12"}>
              <h3>
                <i className={"pi pi-info-circle"}></i> {t('properties')}
              </h3>
            </div>
          </div>
          <div className={"p-grid"}>

              <div className={"p-col-12 p-lg-3"}>
                  <Field name="payment_due_days" render={({input, meta}) => (
                      <div className="p-field p-fluid">
                          <label htmlFor="payment_due_days"
                                 className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldPaymentDueDays')}</label>
                          <div className="p-inputgroup">
                              <InputNumber
                                  id={"payment_due_days"}
                                  value={formData.payment_due_days ?? null}
                                  onValueChange={(e) => {
                                      setFormData({
                                          ...formData,
                                          payment_due_days: e.value
                                      });
                                  }}
                              />
                              <span className="p-inputgroup-addon">{t('day')}</span>

                          </div>
                          {getFormErrorMessage(meta)}
                      </div>
                  )}/>
              </div>
              <div className={"p-col-12 p-md-4 p-lg-9"}>
                  <Field name="active" render={({input, meta}) => (
                      <div className="p-field p-fluid">
                          <label htmlFor="active"
                                 className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldActive')}</label>
                          <span className="p-d-block">
                    <InputSwitch
                        className={"p-mt-1"}
                        checked={formData.active}
                        value={formData.active}
                        onChange={e => setFormData({...formData, active: e.target.value})}/>
                  </span>
                          {getFormErrorMessage(meta)}
                      </div>
                  )}/>
              </div>
            <div className={"p-col-12 p-md-4 p-lg-4"}>
              <Field name="customer" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="customer"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('partnerName')}</label>
                  <span className="p-d-block">
                    <InputSwitch
                      className={"p-mt-1"}
                      checked={formData.customer}
                      value={formData.customer}
                      onChange={e => setFormData({...formData, customer: e.target.value})}/>
                  </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-md-4 p-lg-4"}>
              <Field name="vendor_service" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="vendor_service"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldVendorService')}</label>
                  <span className="p-d-block">
                    <InputSwitch
                      className={"p-mt-1"}
                      checked={formData.vendor_service}
                      value={formData.vendor_service}
                      onChange={e => setFormData({...formData, vendor_service: e.target.value})}/>
                  </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-md-4 p-lg-4"}>
              <Field name="vendor_material" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="vendor_material"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldVendorMaterial')}</label>
                  <span className="p-d-block">
                    <InputSwitch
                      className={"p-mt-1"}
                      checked={formData.vendor_material}
                      value={formData.vendor_material}
                      onChange={e => setFormData({...formData, vendor_material: e.target.value})}/>
                  </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
          </div>
          <div className={"p-grid p-mt-1"}>
            <div className={"p-col-12 p-lg-6 p-xl-6"}>

            </div>
            <div className={"p-col-12 p-lg-6 p-xl-6 p-text-right p-col-align-center"}>
              {entity === 'action' &&
                <Button type="submit" label={t('save')}
                        loading={loading}
                        icon={"pi pi-save"}
                        className="p-button-success p-ml-2"/>
              }
              <Button type="submit" label={t('saveAndBack')}
                      onClick={() => {
                        props = {...props, goback: true}
                      }}
                      loading={loading}
                      icon={"pi pi-arrow-left"}
                      className="p-button-success p-ml-2"/>
            </div>
          </div>
        </form>
      )}/>
    </div>
  )
}
export default withTranslation('common')(PartnerFormComponent);
